import React, { useState, useEffect } from "react";
import axios from "axios";
import parse from "html-react-parser";
import { toast } from "react-toastify";
import { FaEdit } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const Sambutan = () => {
  const [sambutan, setSambutan] = useState("");
  const [idSambutan, setIdSambutan] = useState("");
  const [titleSambutan, setTitleSambutan] = useState("");
  const [imageSambutan, setImageSambutan] = useState("");
  const [videoSambutan, setVideoSambutan] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`/api_w/abouts?title=sambutan`, {
          headers: { db_name: process.env.REACT_APP_DB_NAME },
        });
        const sambutans = response.data.data[0];
        setIdSambutan(sambutans?.id || "");
        setTitleSambutan(sambutans?.title || "");
        setSambutan(sambutans?.body || "");
        setImageSambutan(sambutans?.image_url || "");
        setVideoSambutan(sambutans?.video_url || "");
      } catch (error) {
        toast.error(error.response?.data?.message || error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const renderVideo = (url) => {
    const youtubeMatch = url.match(
      /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/
    );
    const gdriveMatch = url.match(/drive\.google\.com\/file\/d\/([^\/]+)\//);
    let videoUrl = url;
    if (youtubeMatch) videoUrl = `https://www.youtube.com/embed/${youtubeMatch[1]}`;
    else if (gdriveMatch) videoUrl = `https://drive.google.com/file/d/${gdriveMatch[1]}/preview`;
    return (
      <div className="mt-4 overflow-hidden rounded-xl">
        <iframe className="w-full aspect-video" src={videoUrl} title="Video" frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen
        />
      </div>
    );
  };

  return (
    <div className="mt-5 px-2">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-navy-700 dark:text-white">Sambutan</h2>
        <p className="text-sm text-gray-500 mt-1">Kelola konten sambutan pimpinan</p>
      </div>
      {loading ? (
        <div className="py-16 text-center">
          <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-brand-500 border-r-transparent" />
        </div>
      ) : (
        <div className="relative rounded-2xl bg-white shadow-sm p-6 dark:bg-navy-700">
          <button
            onClick={() => navigate(`/admin/edit-sambutan/${idSambutan}`)}
            className="absolute top-5 right-5 flex items-center gap-1.5 rounded-xl bg-blue-50 px-3 py-1.5 text-xs font-medium text-blue-600 hover:bg-blue-100 transition-colors"
          >
            <FaEdit className="h-3 w-3" /> Edit
          </button>
          <h3 className="text-lg font-bold text-navy-700 dark:text-white mb-4 uppercase tracking-wide">{titleSambutan || "Sambutan"}</h3>
          {imageSambutan && (
            <div className="mb-4 overflow-hidden rounded-xl">
              <img src={imageSambutan} alt="sambutan" className="h-48 object-cover" />
            </div>
          )}
          {videoSambutan && renderVideo(videoSambutan)}
          <div className="mt-4 text-sm text-gray-600 leading-relaxed prose max-w-none">{parse(sambutan)}</div>
        </div>
      )}
    </div>
  );
};
export default Sambutan;
